const { fetchAuthenticatedContent } = require("@parallelpublicworks/understory-auth");

module.exports = async function fetchUserData(isAuthenticated, dispatch) {
	let d = false;
	const root_data = isAuthenticated
		? await fetchAuthenticatedContent(dispatch, "/")
		: null;
	if (root_data) {
		if (root_data?.meta?.links?.me?.meta?.id) {
			const user_data = await fetchAuthenticatedContent(
				dispatch,
				"user/user/" + root_data.meta.links.me.meta.id
			);
			if (user_data) {
				const roles =
					user_data.data?.relationships?.roles?.data &&
					Array.isArray(user_data.data.relationships.roles.data) &&
					user_data.data.relationships.roles.data.length > 0
						? user_data.data.relationships.roles.data.map((r) => r.id)
						: [];
				d = { ...user_data.data, roles };
			}
		}
	}
	return d;
};
